module.exports = __webpack_public_path__ + "static/media/3.8a213872.mp3";